import { useEffect, useState } from 'react';
import { getQueryVariable, getVideoLink, openTagIframe } from 'src/components/reel/utils';
import { MenuType, TIframeSettings } from 'src/components/types';
import ThreeInstance from 'src/sdk-components/ThreeInstance';
import { makeThreeInstance, threeInstanceComponentType } from 'src/_models/ThreeInstance.component';
import { isYoutubeUrl } from 'src/utils';

export const useLoadModel = (showcase?: any, publicSweeps?: any, allTags?: any) => {
  const [panorama, setPanorama] = useState({ panoramaOn: false, activePano: 0 });

  const [popUp, setPopUp] = useState({
    externalPopupOn: false,
    overlayOn: false,
    externalPopupUrl: '',
    markerPopupOn: false,
    iframeSettings: {},
  });
  const [tourPlaying, setTourPlaying] = useState(false);

  useEffect(() => {
    if (showcase) {
      (async () => {
        await showcase.Scene.register(threeInstanceComponentType, makeThreeInstance);

        // getting the MP's instance of ThreeJS
        const node = await showcase.Scene.createNode();
        const threeInstance = node.addComponent(threeInstanceComponentType);

        node.start();
        await ThreeInstance.setFromRuntime(threeInstance);
      })();
    }
  }, [showcase]);

  const toggleExternalPopup = (url: string, iframeSettings?: TIframeSettings) => {
    let externalPopupUrl = url;
    if (url && (isYoutubeUrl(url) || url.includes('vimeo.com'))) {
      externalPopupUrl = getVideoLink(url);
    }

    setPopUp({
      overlayOn: !popUp.externalPopupOn,
      externalPopupOn: !popUp.externalPopupOn,
      externalPopupUrl,
      markerPopupOn: false,
      iframeSettings: iframeSettings as TIframeSettings,
    });
  };

  const moveToTagIO = (tagId: string, doOpenTag = true) => {
    if (showcase) {
      setTimeout(() => {
        const tags = Array.from(allTags.values());

        const foundTag: any = tags.find((t: any) => t.sid === tagId);
        if (!foundTag) {
          return;
        }
        showcase.Mattertag.navigateToTag(foundTag.sid, showcase.Mattertag.Transition.FLY)
          .then(() => {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            doOpenTag && openTagIframe(tagId);
          })
          .catch((err: any) => {
            console.error(err.toString());
          });
      }, 100);
    }
  };

  // MISSING PROPS
  // name: string,
  // tour: any,

  const loadModel = async (menu: {
    url?: string;
    type: string;
    tag?: string;
    panoramaId?: number;
    iframeSettings?: TIframeSettings;
    gallery?: any[];
    file?: string;
  }) => {
    const {
      url,
      type,
      tag,
      panoramaId,
      iframeSettings,
      gallery,
      file,
    } = menu;
    if (type === MenuType.Treedis && url) {
      const s: string = getQueryVariable(url, 's');
      const x: string = getQueryVariable(url, 'x');
      const y: string = getQueryVariable(url, 'y');

      showcase.Sweep.moveTo(String(s), {
        rotation: { x: parseFloat(x), y: parseFloat(y) },
        transition: showcase.Sweep.Transition.INSTANT,
      });
    }

    if (
      (type === MenuType.MatterportInstant || type === MenuType.Matterport) &&
      url &&
      publicSweeps
    ) {
      const THREE = await ThreeInstance.get();
      const instant = type === MenuType.MatterportInstant;
      const sr = getQueryVariable(url, 'sr'); //rotation
      const ss = getQueryVariable(url, 'ss'); //sweep

      const linkDataShort: any =
        sr && ss ? { sr: sr.split(','), ss: parseInt(String(ss), 10) } : false;

      const xr = parseFloat(linkDataShort.sr[0] || '0');
      const yr = parseFloat(linkDataShort.sr[1] || '0');
      const zr = parseFloat(linkDataShort.sr[2] || '0');

      const euler = new THREE.Euler().set(xr, yr, zr, 'XYZ').reorder('YXZ');
      const rotation = new THREE.Vector3(euler.x, euler.y, euler.z).multiplyScalar(180 / Math.PI); // @ts-ignore

      rotation.z = 0;
      const scanId = publicSweeps[linkDataShort.ss - 1].sweep_uuid.replace(/-/g, '');

      showcase.Sweep.moveTo(scanId, {
        rotation,
        transition: instant ? showcase.Sweep.Transition.INSTANT : showcase.Sweep.Transition.FLY,
      });
    }
    if (type === MenuType.Tab) {
      window.open(url);
    }
    if (type === MenuType.Panorama && panoramaId) {
      setPanorama({
        panoramaOn: true,
        activePano: panoramaId,
      });
    } else {
      setPanorama({
        panoramaOn: false,
        activePano: 0,
      });
    }
    if (type === MenuType.Popup && url) {
      toggleExternalPopup(url);
    }
    if (type === MenuType.Iframe && url && iframeSettings) {
      toggleExternalPopup(url, iframeSettings);
    }

    if (type === MenuType.Tag && tag !== null) {
      const target = allTags.find((item: any) => {
        return item.sid === tag || item.defaultSid === tag;
      });

      if (!target) {
        return;
      }

      moveToTagIO(target.sid || target.defaultSid, false);
    }
  };

  return {
    loadModel,
    popUp,
    toggleExternalPopup,
    setPanorama,
    tourPlaying,
    setTourPlaying,
    panorama,
  };
};
